import { Component } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { RouterLink, RouterOutlet } from '@angular/router';

import { IconDirective } from '@coreui/icons-angular';
import {
  SidebarComponent,
  ContainerComponent,
  SidebarNavComponent,
  SidebarBrandComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarToggleDirective,
  ShadowOnScrollDirective,
  SidebarTogglerDirective
} from '@coreui/angular';

import { navItems } from './_nav';
import { SessionService } from '../../services/session.service';
import { DefaultFooterComponent, DefaultHeaderComponent } from '.';
import { IconInitDirective } from '../../directives/icon-init.directive'; // adjust path


function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    ContainerComponent,
    SidebarNavComponent,
    SidebarBrandComponent,
    DefaultFooterComponent,
    DefaultHeaderComponent,
    SidebarFooterComponent,
    SidebarHeaderComponent,

    RouterLink,
    NgScrollbar,
    RouterOutlet,

    IconDirective,
    IconInitDirective,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    ShadowOnScrollDirective,
  ]
})
export class DefaultLayoutComponent {
  public navItems = navItems;

  constructor(private sessionService: SessionService) { }

  ngOnInit(): void {
    const user = this.sessionService.getLoggedUser();
    const role = user?.role?.name || 'USER'; // fallback
    this.navItems = this.filterNavItems(navItems, role);
  }

  filterNavItems(items: any[], role: string): any[] {
    return items
      .filter(item => {
        return !item.roles || item.roles.includes(role);
      })
      .map(item => {
        if (item.children) {
          return {
            ...item,
            children: this.filterNavItems(item.children, role)
          };
        }
        return item;
      });
  }

  onScrollbarUpdate($event: any) { }
}
